import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import VenueVerificationLayer from "../components/VenueVerificationLayer";

const VenueVerificationPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Venue Verification Center" />
        <VenueVerificationLayer />
      </MasterLayout>
    </>
  );
};

export default VenueVerificationPage;
